import React from 'react';
import EventsIcon from 'shared/img/college-visit.svg';
import CommunityServiceIcon from 'shared/img/community-service.svg';
import CoursesIcon from 'shared/img/course.svg';
import MultimediaIcon from 'shared/img/art-media.svg';
import WorkExperiencesIcon from 'shared/img/work-experience.svg';
import TestScoresIcon from 'shared/img/test-score.svg';
import CollegeSuccessIcon from 'shared/img/portfolio/college-success.svg';
import ActivitiesIcon from 'shared/img/activity.svg';
import HonorAwardsIcon from 'shared/img/honor-award.svg';

const icons = {
  events: EventsIcon,
  communityService: CommunityServiceIcon,
  courses: CoursesIcon,
  multimedia: MultimediaIcon,
  workExperiences: WorkExperiencesIcon,
  testScores: TestScoresIcon,
  collegeSuccess: CollegeSuccessIcon,
  activities: ActivitiesIcon,
  honorAwards: HonorAwardsIcon,
};

interface Props {
  type: string;
  size: number;
  className?: string;
}

const PortfolioIcon = ({type, size = 50, className}: Props) => {
  const Icon = icons[type];

  return <Icon className={className} width={size} height={size} />;
};

export default PortfolioIcon;
